import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import ReactPlayer from "react-player";
import VideoPanduanPengisian from  "../../assets/PanduanPengerjaanPsikotes.mp4";
import "../styles/modalInstruksi.css";

function ModalInstruksi({ show, onHide, showMulaiButton, psikotesId }) {
  const navigate = useNavigate();

  const btnMulaiClicked = () => {
    navigate(`/psikotes/${psikotesId}`);
  };

  return (
    <Modal
      id="modal-instruksi"
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="true"
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="w-100 text-center modal-title-custom"
        >
          INSTRUKSI PENGISIAN FORM
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column align-items-center">
        <div className="player-wrapper mb-4">
          <ReactPlayer
            url={VideoPanduanPengisian}
            className="react-player"
            width="100%"
            height="100%"
            playing={true}
            controls
          />
        </div>
        <p className="text-center fw-bold px-md-5">
          Pilih Satu (<i className="bi bi-check-lg fw-bold"></i>) dan satu (
          <i className="bi bi-x-lg fw-bold"></i>) pada form dalam satu card
        </p>
      </Modal.Body>
      {showMulaiButton && (
        <Modal.Footer>
          <Button className="btn-mulai-psikotes" onClick={btnMulaiClicked}>
            Mulai Tes
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default ModalInstruksi;
